import React from "react";

import '../styles/layout/loader.scss';

const Loader = () => (
    <div className="loader">Loading...</div>
)

export default Loader;